import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Breadcrumb, { BreadcrumbItem } from '../../components/Breadcrumb';
import ListFilter from './ListFilter';
import AddButton from '../../atoms/AddButton';
import { getAgencies, impersonateAgency } from '../../api/users';
import Loader from '../../atoms/Loader';
import EditableTable from '../../components/Table/EditableTable';
import ToggleActive from './ToggleActive';
import { hasRole } from '../../utils/general';

export default class AgenciesList extends PureComponent {
  state = {
    loading: true,
    data: [],
    locationOptions: [],
    page: 1,
    pages: 1,
    paginated_items: 20,
    filters: {},
  }

  async componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    try {
      const { page, filters } = this.state;
      const { items: data, total } = await getAgencies({ ...filters, page }, this.props.site);
      this.setState({
        data,
        pages: Math.ceil(total / 20) || 1,
      });
    } catch (e) {
      console.error(e);
    } finally {
      this.setState({ loading: false });
    }
  }

  handleFilters = (filters) => this.setState({ filters, page: 1 }, this.fetchData)

  handlePagination = (page) => this.setState({ page: page + 1 }, this.fetchData)

  handleImpersonateAgency = (id) => {
    this.setState({ loading: true });

    impersonateAgency(id).finally(() => {
      this.setState({ loading: false });
    });
  }

  render() {
    const columns = [
      {
        id: 'ragioneSociale',
        Header: 'Ragione Sociale',
        accessor: (d) => {
          return <Link to={`/admin/agenzie/${d.id}`}>{d.ragioneSociale}</Link>;
        },
      },
      {
        id: 'pIva',
        Header: 'P.IVA',
        accessor: (d) => d.pIva || <Empty />,
      },
      {
        id: 'email',
        Header: 'Email',
        accessor: (d) => d.email,
      },
      {
        id: 'pec',
        Header: 'PEC',
        accessor: (d) => d.pec || <Empty />,
      },
      {
        id: 'codiceFiscale',
        Header: 'Codice Fiscale',
        accessor: (d) => d.codiceFiscale || <Empty />,
      },
      {
        id: 'attivo',
        Header: 'Attivo',
        disableSortBy: true,
        accessor: (d) => <ToggleActive id={d.id} checked={d.enabled} />,
      },
      {
        id: 'actions',
        Header: 'Azioni',
        disableSortBy: true,
        accessor: (d) => {
          return (
            <ActionsContainer>
              <Link to={`/admin/agenzie/${d.id}`} className="button is-outlined mar-right-10">
                <i className="mi mi-edit" title="Modifica" />
              </Link>

              {hasRole('super-admin') && (
                <button onClick={() => this.handleImpersonateAgency(d.id)} className="button is-outlined mar-right-10">
                  <i className="mi mi-person" title="Impersona" />
                </button>
              )}
            </ActionsContainer>
          );
        },
      },
    ];

    return (
      <div>
        <Breadcrumb>
          <BreadcrumbItem>Agenzie</BreadcrumbItem>
        </Breadcrumb>

        <Row>
          <p>Filtra i risultati</p>
        </Row>

        <ListFilter onSubmit={this.handleFilters} />

        <div className="add-button">
          <AddButton path="/admin/agenzie/new" />
        </div>

        <EditableTable
          data={this.state.data}
          columns={columns}
          page={this.state.page - 1}
          pages={this.state.pages}
          onPageChange={this.handlePagination}
        />

        {this.state.loading && <Loader />}
      </div>
    );
  }
}

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Empty = styled.span`
  display: inline;
  color: #999;
  user-select: none;
`;

Empty.defaultProps = {
  children: '--',
};
